import { useSelector } from 'react-redux';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';

export const ADMIN_ROLE_ID = 1;

export const useCurrentRole = (): { roleId: number | null; isAdmin: boolean } => {
  // Use the SAME selector RestrictedRoute uses (found in Step 4 grep).
  const roleId = useSelector(loggedInUserSelectors.role) ?? null;
  return { roleId, isAdmin: roleId === ADMIN_ROLE_ID };
};
